import React from 'react'
import { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';



const AvpNodePropertiesSection = forwardRef( function(props, ref) {  


  const [formDescrStatus, setFormDescrStatus] = useState('')
  const [currentNode, setCurrentNode] = useState(null)


  const descRef = React.useRef();
  const tipoAvvioRef = React.useRef();
  const apiEsternaRef = React.useRef();
  const flagGoBackRef = React.useRef();

  if (currentNode==null || (currentNode!=null && currentNode.idNodo!=props.node.idNodo)) {
    let tempNodo = Object.assign({}, props.node);
    setCurrentNode(tempNodo);
  }


  useEffect(() => {

    
  }, [props]);


  useImperativeHandle(ref, () => ({
    getData() {
      return getNodeData();
    }
  })); 
  
  function getNodeData() {
    if (validateForm()) {
      //if (currentNode.nodoStart==false) {
        const descNodo = descRef.current.value;
        const tipoAvvio = tipoAvvioRef.current.value;
        const apiEsterna = apiEsternaRef.current.value;   
        const flagGoBack = flagGoBackRef.current.checked;   
        let data = {
          descNodo: descNodo,
          tipoAvvio: tipoAvvio,
          apiEsterna: apiEsterna,
          flagGoBack: flagGoBack,
          pipAvatarX: currentNode.pipAvatarX,
          pipAvatarY: currentNode.pipAvatarY,
          pipAvatarW: currentNode.pipAvatarW,
          pipAvatarH: currentNode.pipAvatarH,
          pipAvatarZ: currentNode.pipAvatarZ,
          pipContentsX: currentNode.pipContentsX,
          pipContentsY: currentNode.pipContentsY,
          pipContentsW: currentNode.pipContentsW,
          pipContentsH: currentNode.pipContentsH,
          pipContentsZ: currentNode.pipContentsZ,
        }
        return data;
      //}

      return null;
    }
    else
      return null;

  }


  function validateForm() {
    let valid = true;

    //if (currentNode.nodoStart==false) {
      const descNodo = descRef.current.value;
      const tipoAvvio = tipoAvvioRef.current.value;
      const apiEsterna = apiEsternaRef.current.value;
  
      if (descNodo==null || descNodo=="") {
        valid = false;
        setFormDescrStatus(" notvalid");
      }
      else {
        setFormDescrStatus("");
      }
    //}

    return valid;    
  }

  function onDescChange(event) {
    let value = event.target.value;
    currentNode.descNodo = value;
    let newNodo = Object.assign({}, currentNode);
    setCurrentNode(newNodo);
  }

  function onTipoAvvioChange(event) {
    let value = event.target.value;
    currentNode.tipoAvvio = value;
    let newNodo = Object.assign({}, currentNode);
    setCurrentNode(newNodo);
  }  

  function onApiEsternaChange(event) {
    let value = event.target.value;
    currentNode.apiEsterna = value;
    let newNodo = Object.assign({}, currentNode);
    setCurrentNode(newNodo);
  }  

  function onFlagGoBackChange(event) {
    let value = event.target.checked;
    currentNode.flagGoBack = value;
    let newNodo = Object.assign({}, currentNode);
    setCurrentNode(newNodo); 

  }  

  function changeNodeProp(event, prop) {
    let value = event.target.value;
    currentNode[prop] = parseInt(value);
    let newNodo = Object.assign({}, currentNode);
    setCurrentNode(newNodo);
  }


  if (currentNode!=null  ) {

    return (
      <div id="avp-gestioneavp-node-properties-section"  >
  
          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-descr" className='required' >Nome</label><br/>
              <input ref={descRef} id="avp-form-descr" className={formDescrStatus} type='text' value={currentNode!=null ? currentNode.descNodo : ''}  onChange={onDescChange}  />
            </div>  
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-codeasset" className='required'>Tipo avvio</label><br/>
              <select value={currentNode!=null ? currentNode.tipoAvvio : ""} ref={tipoAvvioRef} onChange={onTipoAvvioChange} >
                { 
                  props.tipoAvvioList!=null ?
                    props.tipoAvvioList.map((tipo, i) => { 
                      return (<option key={tipo.idTipoAvvio} value={tipo.idTipoAvvio}  >{tipo.descTipoAvvio}</option>) 
                    })
                  : (<option></option>)
                }  
              </select>            
            </div>              
          </div>

          <div className="avp-cms-screen-content-row clearfix" style={{ display: currentNode.tipoAvvio==3 ? "block" : "none"}}>
            <div>Avatar</div> 
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-avatar-posx"  >Pos X(%)</label><br/>
              <input id="avp-form-pip-avatar-posx"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipAvatarX!=null && currentNode.pipAvatarX!="undefined" ? currentNode.pipAvatarX : '0'} onChange={(e)=>changeNodeProp(e, "pipAvatarX")}  />
            </div>  
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-avatar-posy"  >Pos Y(%)</label><br/>
              <input id="avp-form-pip-avatar-posy"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipAvatarY!=null && currentNode.pipAvatarY!="undefined" ? currentNode.pipAvatarY : '0'}  onChange={(e)=>changeNodeProp(e, "pipAvatarY")}  />
            </div>
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-avatar-dimw"  >Dim W(%)</label><br/>
              <input id="avp-form-pip-avatar-dimw"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipAvatarW!=null && currentNode.pipAvatarW!="undefined" ? currentNode.pipAvatarW : '100'}  onChange={(e)=>changeNodeProp(e, "pipAvatarW")}  />
            </div>         
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-avatar-dimh"  >Dim H(%)</label><br/>
              <input id="avp-form-pip-avatar-dimh"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipAvatarH!=null && currentNode.pipAvatarH!="undefined" ? currentNode.pipAvatarH : '100'}  onChange={(e)=>changeNodeProp(e, "pipAvatarH")}  />
            </div>       
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-avatar-z"  >Z-index</label><br/>
              <input id="avp-form-pip-avatar-z"  type='number' min="0" max="250"  value={currentNode!=null && currentNode.pipAvatarZ!=null && currentNode.pipAvatarZ!="undefined" ? currentNode.pipAvatarZ : '0'}  onChange={(e)=>changeNodeProp(e, "pipAvatarZ")}  />
            </div>   
          </div>  
          <div className="avp-cms-screen-content-row clearfix" style={{ display: currentNode.tipoAvvio==3 ? "block" : "none"}}>
            <div>Contenuti</div> 
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-playlist-posx"  >Pos X(%)</label><br/>
              <input id="avp-form-pip-playlist-posx"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipContentsX!=null && currentNode.pipContentsX!="undefined" ? currentNode.pipContentsX : '0'}  onChange={(e)=>changeNodeProp(e, "pipContentsX")}  />
            </div>  
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-playlist-posy"  >Pos Y(%)</label><br/>
              <input id="avp-form-pip-playlist-posy"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipContentsY!=null && currentNode.pipContentsY!="undefined" ? currentNode.pipContentsY : '0'}  onChange={(e)=>changeNodeProp(e, "pipContentsY")}  />
            </div>
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-playlist-dimw"  >Dim W(%)</label><br/>
              <input id="avp-form-pip-playlist-dimw"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipContentsW!=null && currentNode.pipContentsW!="undefined" ? currentNode.pipContentsW : '100'}  onChange={(e)=>changeNodeProp(e, "pipContentsW")}  />
            </div>         
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-playlist-dimh"  >Dim H(%)</label><br/>
              <input id="avp-form-pip-playlist-dimh"  type='number' min="0" max="100"  value={currentNode!=null && currentNode.pipContentsH!=null && currentNode.pipContentsH!="undefined" ? currentNode.pipContentsH : '100'}  onChange={(e)=>changeNodeProp(e, "pipContentsH")}  />
            </div>       
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pip-playlist-z"  >Z-index</label><br/>
              <input id="avp-form-pip-playlist-z"  type='number' min="0" max="250"  value={currentNode!=null && currentNode.pipContentsZ!=null && currentNode.pipContentsZ!="undefined" ? currentNode.pipContentsZ : '0'}  onChange={(e)=>changeNodeProp(e, "pipContentsZ")}  />
            </div>   
          </div>
          
          <div className="avp-cms-screen-content-row clearfix">
            <label htmlFor="avp-form-apiesterna" className='required'>Api esterna</label><br/>
            <textarea ref={apiEsternaRef} id="avp-form-apiesterna" type='text' style={{"maxWidth":"none"}}  rows="4" value={currentNode!=null && currentNode.apiEsterna!=null ? currentNode.apiEsterna : ''} onChange={onApiEsternaChange} ></textarea>
          </div>
  
          <div className="avp-cms-screen-content-row clearfix">
            <input id="avp-form-flagGoBack" ref={flagGoBackRef} type='checkbox' onChange={onFlagGoBackChange}  checked={currentNode!=null && currentNode.flagGoBack ? "checked" : ""} />            
            <label htmlFor="avp-form-flagGoBack">Flag Go Back</label>
          </div>

              

      </div>     
    );
 
  }
  else {
    return ( <div id="avp-gestioneavp-node-properties-section"  ></div>);
  }
  

}); 
export default AvpNodePropertiesSection;
